export default __webpack_public_path__ + "static/media/waihuo.646d29ad.png";